import { useState, useEffect } from "react";
import { TrendingUp, TrendingDown } from "lucide-react";
import api from "@/lib/api";

const FALLBACK = [
  { symbol: "IHSG", price: 7842.15, change_pct: 0.62 },
  { symbol: "BBCA", price: 10250, change_pct: 1.24 },
  { symbol: "BBRI", price: 4180, change_pct: -0.71 },
  { symbol: "BMRI", price: 6775, change_pct: 0.89 },
  { symbol: "BREN", price: 8925, change_pct: 3.48 },
];

const fmt = (n) => (n >= 1000 ? Math.round(n).toLocaleString("id-ID") : n.toFixed(2));

const TickerItem = ({ t }) => {
  const up = (t.change_pct ?? 0) >= 0;
  return (
    <div className="flex items-center gap-2 px-5 border-r border-[var(--border-subtle)] whitespace-nowrap">
      <span className="font-heading font-bold text-sm text-[var(--text-primary)]">{t.symbol}</span>
      <span className="font-mono-data text-sm text-[var(--text-secondary)]">{fmt(t.price)}</span>
      <span className={`font-mono-data text-xs flex items-center gap-0.5 ${up ? "text-bull" : "text-bear"}`}>
        {up ? <TrendingUp size={12} /> : <TrendingDown size={12} />}
        {up ? "+" : ""}{(t.change_pct ?? 0).toFixed(2)}%
      </span>
    </div>
  );
};

export default function Ticker() {
  const [quotes, setQuotes] = useState(FALLBACK);
  const [live, setLive] = useState(false);

  useEffect(() => {
    let alive = true;
    const load = async () => {
      try {
        const res = await api.get("/quotes");
        if (alive && res.data.quotes?.length) {
          setQuotes(res.data.quotes);
          setLive(true);
        }
      } catch (e) {}
    };
    load();
    const id = setInterval(load, 60000);
    return () => { alive = false; clearInterval(id); };
  }, []);

  const doubled = [...quotes, ...quotes];
  return (
    <div className="w-full bg-[var(--surface-base)] border-b border-[var(--border)] overflow-hidden flex items-center" data-testid="ticker-bar">
      <div className="shrink-0 px-3 py-2 flex items-center gap-1.5 border-r border-[var(--border)] bg-[var(--surface-card)]">
        <span className={`w-1.5 h-1.5 rounded-full ${live ? "bg-[var(--bull)] animate-pulse" : "bg-[var(--text-muted)]"}`} />
        <span className="text-[10px] font-mono-data text-[var(--text-muted)] uppercase tracking-wider">{live ? "Live" : "Delayed"}</span>
      </div>
      <div className="flex marquee-track animate-marquee w-max py-2">
        {doubled.map((t, i) => (
          <TickerItem key={i} t={t} />
        ))}
      </div>
    </div>
  );
}
